<h3 class="app w-full mb-2 mt-[25px]">{{data.businessName}} - {{data.policyNumber}}</h3>
<p class="mb-4">Please make any updates to location and operations information. If no changes, proceed to Price.</p>
<form [formGroup]="form()!">
    <section class="flex flex-col mt-[40px]">
        <h3 class="app mb-4">Rating Factors</h3>
        <div class="w-full flex gap-[35px]">
            <div class="w-1/2">
                <lib-form-dropdown label="Does applicant perform new residential construction work?" [manualOptions]="[
          { id: '1', name: 'Yes', value: true},
          { id: '2', name: 'No', value: false}
          ]" formControlName="performsNewResConstruction">
                </lib-form-dropdown>
                <div *ngIf="wizardStore.addAppropriateClassCodeError()">
                    <mat-error>
                        When performing New Residential work, be sure to add the appropriate class codes.
                    </mat-error>
                </div>
            </div>
            <lib-form-money class="w-1/2" label="Annual Gross Receipts"
                formControlName="grossReceipts"></lib-form-money>
        </div>
        <div class="w-full flex gap-[35px]">
            <lib-form-dropdown class="w-1/2" label="How many owners are active in the field?"
                [manualOptions]="fieldOwnerOptions" formControlName="numberOfFieldOwners">
            </lib-form-dropdown>
            <!-- Calculated from the number of field owners, so it's display-only -->
            <div class="w-1/2">
                <p class="semi-bold mb-0">Owner Payroll</p>
                <p class="mb-0">{{ wizardStore.ownerPayroll() | currency:'USD':'symbol':'1.0-0' }}</p>
            </div>
        </div>
        <div class="w-full flex gap-[35px]">
            <lib-form-dropdown class="w-1/2" label="How many employees does the applicant have?"
                [manualOptions]="employeeOptions" formControlName="numberOfEmployees">
            </lib-form-dropdown>
            <!-- "Must be greater than $0 when there are employees" is shown by the control's validator -->
            <lib-form-money class="w-1/2" label="Employee Payroll" formControlName="employeePayroll"></lib-form-money>
        </div>
        <div class="w-full flex gap-[35px]">
            <lib-form-money class="w-1/2" label="Residential Subcontractor Labor Costs (Class 91583)"
                formControlName="residentialSubcontractorCosts"></lib-form-money>
            <lib-form-money class="w-1/2" label="Commercial Subcontractor Labor Costs (Class 91585)"
                formControlName="commercialSubcontratorCosts"></lib-form-money>
        </div>
        <div class="w-full flex flex-col mt-[40px]" formArrayName="classes">
            <h3 class="app mb-4">Classifications</h3>
            <!-- If you track index rather than class, as suggested by error NG0956, it breaks how the classes get added/removed form the array. -->
            @for (class of classesFormArray.controls; track class; let i = $index) {
            <div class="w-full flex gap-[35px]" [formGroupName]="i">

                <lib-form-dropdown class="w-1/2" floatLabel="always"
                    [label]="i === 0 ? 'Applicant\'s Primary Classification' : 'Applicant\'s Additional Classification'"
                    [options]="lookupStore.programClasses()!" formControlName="classCode">
                </lib-form-dropdown>


                @if (i > 0) {
                <div class="custom-padding-class"> <!-- add your padding class here -->
                    <mat-form-field class="w-full" floatLabel="always">
                        <mat-label>Percentage of work</mat-label>
                        <input matInput type="number" formControlName="percentageOfWork" min="1" max="100" step="1"
                            onkeydown="return event.key !== '.' && event.key !== 'e' && event.key !== 'E' && event.key !== '+' && event.key !== '-'" />
                        <span matTextSuffix>%</span>
                        <mat-error>{{ class.get('percentageOfWork')?.hasError('required') ? 'Required' : 'Enter a percentage from 1 to 100' }}</mat-error>
                    </mat-form-field>

                    <a class="w-4 pl-5 flex justify-center items-center cursor-pointer" (click)="removeClass(i)">
                        <lib-icon icon="close" class="w-4"></lib-icon>
                    </a>
                </div>
                } @else {
                <mat-form-field class="w-1/2" floatLabel="always">
                        <mat-label>Percentage of work</mat-label>
                        <input matInput type="number" formControlName="percentageOfWork" min="1" max="100" step="1"
                            onkeydown="return event.key !== '.' && event.key !== 'e' && event.key !== 'E' && event.key !== '+' && event.key !== '-'" />
                        <span matTextSuffix>%</span>
                        <mat-error>{{ class.get('percentageOfWork')?.hasError('required') ? 'Required' : 'Enter a percentage from 1 to 100' }}</mat-error>
                    </mat-form-field>
                }

            </div>
            }
        </div>

        <div class="w-full flex gap-[35px]">
            <div class="w-1/2">
                <lib-button [cssType]="'btn-link'" [text]="'Add Classification'" [icon]="'circleplus'"
                    [buttonType]="'button'" (click)="addClass()"></lib-button>
            </div>
            <div class="w-1/2">
                <p class="large">
                    <span class="font-semibold">
                        Total Payroll:
                    </span>
                    <span class="ml-1">
                        {{ wizardStore.totalPayroll() | currency }}
                    </span>
                </p>
                @if( wizardStore.totalPayroll() < 20000 && wizardStore.totalPayroll() !==0) { <p class="text-red">
                    Error: Minimum Payroll is $20,000
                    </p>
                    } @else if (wizardStore.duplicateClasses()) {
                    <p class="text-red">
                        Error: Duplicate classes present, remove duplicate. Add additional payroll to the first entry
                        for each class.
                    </p>
                    }
            </div>
        </div>
        <!-- Total of the classes' percentage of work; hidden until a percentage is filled in -->
        @if (wizardStore.totalClassPercentage() > 0) {
        <div class="w-full flex gap-[35px]">
            <div class="w-1/2"></div>
            <div class="w-1/2">
                <p class="large font-semibold mb-0">{{ wizardStore.totalClassPercentage() }}%</p>
                @if (wizardStore.totalClassPercentage() !== 100) {
                <p class="text-red">Must equal 100%</p>
                }
            </div>
        </div>
        }
    </section>
    <section class="flex flex-wrap flex-row">
        <!-- OPERATIONS DESCRIPTION -->
        <div class="w-full  gap-[35px] mt-[40px] ">
            <h4 class="mb-4">Description of Operations</h4>
            <p>Please Describe Your Work</p>
            <lib-form-text-area class="w-full" placeholder="Description of operations goes here."
                formControlName="descriptionOfOperations" row="4" maxlength="5000"></lib-form-text-area>
        </div>
        <!-- PERCENTAGE OF WORK -->
        <h4 class="mt-[40px]">Percentage of Work</h4>
        <div class="w-full flex gap-[35px] justify-between items-center" style="border-bottom: 1px solid #999999;">
            <div>
                <p>Residential - New Construction</p>
            </div>
            <div class="flex items-center gap-3">
                <span>
                    <p class="semi-bold mb-0">% of work</p>
                </span>
                <span>
                    <lib-form-text [alignment]="'center'" type="number" class="w-1/2" label=""
                        formControlName="percentageResidentialNew" mask="999">
                    </lib-form-text>
                </span>
            </div>
        </div>
        <div class="w-full flex gap-[35px] justify-between items-center" style="border-bottom: 1px solid #999999;">
            <div>
                <p>Residential - Remodel, Service, & Repair</p>
            </div>
            <div class="flex items-center gap-3">
                <span>
                    <p class="semi-bold mb-0">% of work</p>
                </span>
                <span>
                    <lib-form-text [alignment]="'center'" type="number" class="w-1/2" label=""
                        formControlName="percentageResidentialRemodel" mask="999">
                    </lib-form-text>
                </span>
            </div>
        </div>
        <div class="w-full flex gap-[35px] justify-between items-center" style="border-bottom: 1px solid #999999;">
            <div>
                <p>Commercial - New Construction</p>
            </div>
            <div class="flex items-center gap-3">
                <span>
                    <p class="semi-bold mb-0">% of work</p>
                </span>
                <span>
                    <lib-form-text [alignment]="'center'" type="number" class="w-1/2" label=""
                        formControlName="percentageCommercialNew" mask="999">
                    </lib-form-text>
                </span>
            </div>
        </div>
        <div class="w-full flex gap-[35px] justify-between items-center" style="border-bottom: 1px solid #999999;">
            <div>
                <p>Commercial - Remodel, Service, & Repair</p>
            </div>
            <div class="flex items-center gap-3">
                <span>
                    <p class="semi-bold mb-0">% of work</p>
                </span>
                <span>
                    <lib-form-text [alignment]="'center'" type="number" class="w-1/2" label=""
                        formControlName="percentageCommercialRemodel" mask="999">
                    </lib-form-text>
                </span>
            </div>
        </div>
        <div class="w-full flex gap-[35px] justify-between items-center" style="border-bottom: 1px solid #999999; display:none">
            <div>
                <p>Industrial - New Construction</p>
            </div>
            <div class="flex items-center gap-3">
                <span>
                    <p class="semi-bold mb-0">% of work</p>
                </span>
                <span>
                    <lib-form-text [alignment]="'center'" type="number" class="w-1/2" label=""
                        formControlName="percentageIndustrialNew" mask="999">
                    </lib-form-text>
                </span>
            </div>
        </div>
        <div  class="w-full flex gap-[35px] justify-between items-center" style="border-bottom: 1px solid #999999; display:none">
            <div>
                <p>Industrial - Remodel, Service, & Repair</p>
            </div>
            <div class="flex items-center gap-3">
                <span>
                    <p class="semi-bold mb-0">% of work</p>
                </span>
                <span>
                    <lib-form-text [alignment]="'center'" type="number" class="w-1/2" label=""
                        formControlName="percentageIndustrialRemodel" mask="999">
                    </lib-form-text>
                </span>
            </div>
        </div>
        <div class="w-full flex flex-col items-end mt-4">
            <h4>Total %: <span class="inline-block text-center" style="width: 180px;">{{
                    wizardStore.totalPercentageWork() }}</span></h4>
            <p class="small">Must equal 100% <span class="inline-block text-center" style="width: 180px;"></span></p>
            @if (wizardStore.totalPercentageWork() !== 100 && wizardStore.totalPercentageWork() !== 0) {
            <p class="error">Percetage must equal 100</p>
            }
        </div>
        <!-- ADDRESS INFO -->
        <h4 class="mt-[40px]">Primary Business Address</h4>
        <div class="w-full flex gap-[35px]">
            <lib-form-text class="w-1/2" label="Street Address" formControlName="locationAddress1"
                maxlength="50"></lib-form-text>
            <lib-form-text class="w-1/2" label="Suite number" formControlName="locationAddress2"></lib-form-text>
        </div>
        <div class="w-full flex gap-[35px]">
            <lib-form-text class="w-1/2" label="City" formControlName="city" maxlength="64"></lib-form-text>
            <div class="flex w-1/2 gap-[35px]">
                <lib-form-dropdown class="w-1/2" label="State" [options]="lookupStore.programStates()!"
                    formControlName="state" maxlength="2"></lib-form-dropdown>
                <lib-form-text class="w-1/2" label="Zip Code" formControlName="zipCode" mask="99999"
                    maxlength="10"></lib-form-text>
            </div>
        </div>

    </section>
</form>